import { ZodIssue } from 'zod'

const IS_REQUIRED = "IS_REQUIRED"
const INVALID_TYPE = "INVALID_TYPE"
export const NOT_NUMBER = "NOT_NUMBER"
export const NOT_POSITIVE = "NOT_POSITIVE"

type issueExtends = {
  type?: string
}

const useZodErrorParse = (errors: ZodIssue[] = [], fieldId: string) => {
  const isError: ZodIssue & issueExtends | false = errors.find(e => e.path.includes(fieldId)) ?? false // pass in a default for getting zod types

  const errorCode = () => {
    if (isError) {
      const zod_code = isError.code
      switch (zod_code) {
        case "too_small": {
          if (isError.type === "number" && isError.message === NOT_POSITIVE) return NOT_NUMBER
          else return IS_REQUIRED
        }
        case "invalid_type": {
          if (isError.expected === "number" || isError.received === "nan") return NOT_NUMBER
          else return INVALID_TYPE
        }
        case "invalid_string": {
          if(isError.validation === "regex" && isError.message === NOT_NUMBER) return NOT_NUMBER
          else return INVALID_TYPE
        }
        default:
          return ""
      }
    }
    return ""
  }

  return {
    isError,
    errorCode: errorCode()
  }
}

export default useZodErrorParse